export default "/images/dc34f10056c199d8b7b1f7bb15bd472c.avif";